export default {
  projectTypes: {
    nature_based: "Nature Based / Land Use (AFOLU)",
    energy_industry: "Energy & Industry",
    waste_methane: "Waste & Methane",
    carbon_removal: "Carbon Removal & Novel Tech",
    community_development: "Community & Development",
  },
  certifiers: {
    verra: "Verra",
    goldstandard: "Gold Standard",
    gcc: "GCC",
    tero: "Tero",
    planvivo: "Plan Vivo",
    arttrees: "ART TREES",
    socialcarbon: "Social Carbon",
    equitableearth: "Equitable Earth",
    isometric: "Isometric",
    puro: "Puro.earth",
  },
  methodologies: {
    afforestation_reforestation_ghg_emissions_reductions_sequestration_methodology:
      "Afforestation - Reforestation GHG Emissions Reductions & Sequestration Methodology",
    agroforestry: "Agroforestry",
    ar_acm0003_afforestation_and_reforestation_of_lands:
      "AR-ACM0003 - Afforestation and Reforestation of Lands",
    art_trees: "ART-TREES",
    art_trees_removals: "ART-TREES-removals",
    biochar: "Biochar",
    biochar_production_and_storage: "Biochar Production and Storage",
    biogenic_carbon_capture_and_storage:
      "Biogenic Carbon Capture and Storage",
    biomass_fermentation_with_carbon_capture_and_geologic_storage:
      "Biomass Fermentation with Carbon Capture and Geologic Storage",
    carbon_mineralisation_using_reactive_mineral_waste:
      "Carbon Mineralisation using Reactive Mineral Waste",
    carbonated_materials: "Carbonated Materials",
    direct_air_capture_and_ocean_storage:
      "Direct Air Capture and Ocean Storage",
    direct_ocean_capture_and_storage: "Direct Ocean Capture and Storage",
    electrolytic_seawater_mineralization:
      "Electrolytic Seawater Mineralization",
    emission_reduction_by_shore_side_or_off_shore_electricity_supply_system:
      "Emission Reduction by Shore-side or Off-shore Electricity Supply System",
    emission_reductions_from_safe_drinking_water_supply:
      "Emission Reductions from Safe Drinking Water Supply",
    enhanced_rock_weathering: "Enhanced Rock Weathering",
    gccm001_methodology_for_renewable_energy_generation_projects_supplying_electricity_to_grid_or_captive_consumers:
      "GCCM001 - Methodology for Renewable Energy Generation Projects Supplying Electricity to Grid or Captive Consumers",
    gccm002_methodology_for_energy_saving_in_pumping_systems:
      "GCCM002 - Methodology for Energy Saving in Pumping Systems",
    gccm003_methodology_for_energy_generation_from_animal_manure_and_waste_management_projects:
      "GCCM003 - Methodology for Energy Generation from Animal Manure and Waste Management Projects",
    gccm004_methodology_for_water_grid_connected_renewable_energy_based_desalination_plant:
      "GCCM004 - Methodology for Water Grid Connected Renewable Energy Based Desalination Plant",
    gccm005_methodology_for_desalinated_water_savings_in_buildings:
      "GCCM005 - Methodology for Desalinated Water Savings in Buildings",
    gccm006_energy_efficiency_measures_in_existing_centralized_cooling_systems:
      "GCCM006 - Energy Efficiency Measures in Existing Centralized Cooling Systems",
    gccm007_methodology_for_private_carpooling_for_long_distance_inter_urban_travel:
      "GCCM007 - Methodology for Private Carpooling for Long-Distance Inter-Urban Travel",
    gccma001_gcc_nbs_methodology_for_forestry_project_activities_on_lands_except_wetlands:
      "GCCMA001 - GCC NBS Methodology for Forestry Project Activities on Lands Except Wetlands",
    gccma002_gcc_nbs_methodology_for_project_activities_on_degraded_mangrove_habitats:
      "GCCMA002 - GCC NBS Methodology for Project Activities on Degraded Mangrove Habitats",
    gccma003_gcc_nbs_methodology_for_rewetting_drained_peatlands:
      "GCCMA003 - GCC NBS Methodology for Rewetting Drained Peatlands",
    gccmt001_methodology_for_project_activities_involving_the_capture_transport_and_geological_storage_of_carbon_dioxide:
      "GCCMT001 - Methodology for Project Activities Involving the Capture, Transport, and Geological Storage of Carbon Dioxide",
    geologically_stored_carbon: "Geologically Stored Carbon",
    improved_forest_management: "Improved Forest Management",
    in_situ_capture_and_conversion_of_cattle_enteric_methane:
      "In-situ Capture and Conversion of Cattle Enteric Methane",
    m001_terrestrial_forest_restoration:
      "M001 - Terrestrial Forest Restoration",
    m002_terrestrial_forest_conservation:
      "M002 - Terrestrial Forest Conservation",
    mangrove_restoration: "Mangrove Restoration",
    marine_anoxic_carbon_storage: "Marine Anoxic Carbon Storage",
    methane_emission_reduction_by_adjusted_water_management_practice_in_rice_cultivation:
      "Methane Emission Reduction by Adjusted Water Management Practice in Rice Cultivation",
    methane_emissions_reduction_from_enteric_fermentation_in_beef_cattle_through_application_of_feed_supplements_under_revision:
      "Methane Emissions Reduction from Enteric Fermentation in Beef Cattle through Application of Feed Supplements (under revision)",
    methodology_for_animal_manure_management_and_biogas_use_for_thermal_energy_generation:
      "Methodology for Animal Manure Management and Biogas Use for Thermal Energy Generation",
    methodology_for_collection_of_sargassum_and_other_macroalgae_to_avoid_emissions_from_decomposition_and_to_use_for_beneficial_products:
      "Methodology for Collection of Sargassum and Other Macroalgae to Avoid Emissions from Decomposition and to Use for Beneficial Products",
    methodology_for_marine_fuels_and_biobunkers:
      "Methodology for Marine Fuels and Biobunkers",
    methodology_for_metered_measured_energy_cooking_devices:
      "Methodology for Metered & Measured Energy Cooking Devices",
    methodology_for_reducing_methane_emissions_from_combustion_engine_exhaust:
      "Methodology for Reducing Methane Emissions from Combustion Engine Exhaust",
    microalgae_carbon_fixation_and_sinking:
      "Microalgae Carbon Fixation and Sinking",
    microbial_carbon_di_oxide_mineralisation:
      "Microbial Carbon Di-oxide Mineralisation",
    ocean_alkalinity_enhancement_from_coastal_outfalls:
      "Ocean Alkalinity Enhancement from Coastal Outfalls",
    open_system_ex_situ_mineralization: "Open System Ex-situ Mineralization",
    pm001_agriculture_forestry_carbon_benefit_assessment_methodology:
      "PM001 - Agriculture & Forestry Carbon Benefit Assessment Methodology",
    pm002_methodology_for_quantifying_carbon_benefits_from_small_scale_agroforestry:
      "PM002 - Methodology for Quantifying Carbon Benefits from Small-Scale Agroforestry",
    recovery_and_recycling_of_materials_from_solid_wastes:
      "Recovery and Recycling of Materials from Solid Wastes",
    reduced_emissions_from_cooking_and_heating_technologies_and_practices_to_displace_decentralised_thermal_energy_consumption_tpddtec:
      "Reduced Emissions from Cooking and Heating - Technologies and Practices to Displace Decentralised Thermal Energy Consumption (TPDDTEC)",
    reducing_methane_emissions_from_enteric_fermentation_in_dairy_cows_through_application_of_feed_supplements_under_revision:
      "Reducing Methane Emissions from Enteric Fermentation in Dairy Cows through Application of Feed Supplements (under revision)",
    reduction_in_methane_emissions_from_landfills_through_decentralised_organic_waste_processing:
      "Reduction in Methane Emissions from Landfills through Decentralised Organic Waste Processing",
    reforestation: "Reforestation",
    river_alkalinity_enhancement: "River Alkalinity Enhancement",
    scm0003_carbon_removal_in_private_conservation_areas:
      "SCM0003 - Carbon Removal in Private Conservation Areas",
    soil_organic_carbon_activity_module_biostimulants_for_soil_revitalisation:
      "Soil Organic Carbon Activity Module - Biostimulants for Soil Revitalisation",
    soil_organic_carbon_activity_module_for_application_of_organic_soil_improvers_from_pulp_and_paper_mill_sludges:
      "Soil Organic Carbon Activity Module for Application of Organic Soil Improvers from Pulp and Paper Mill Sludges",
    soil_organic_carbon_activity_module_for_cover_crops:
      "Soil Organic Carbon Activity Module for Cover Crops",
    soil_organic_carbon_activity_module_for_enhancing_carbon_stocks_in_managed_pasture:
      "Soil Organic Carbon Activity Module for Enhancing Carbon Stocks in Managed Pasture",
    soil_organic_carbon_activity_module_for_zero_tillage:
      "Soil Organic Carbon Activity Module for Zero Tillage",
    soil_organic_carbon_activity_module_increasing_soil_carbon_through_improved_tillage_practices:
      "Soil Organic Carbon Activity Module: Increasing Soil Carbon Through Improved Tillage Practices",
    soil_organic_carbon_framework_methodology:
      "Soil Organic Carbon Framework Methodology",
    subsurface_biomass_carbon_removal_and_storage:
      "Subsurface Biomass Carbon Removal and Storage",
    suppressed_demand_methodology_micro_scale_electrification_and_energization_under_revision:
      "Suppressed Demand Methodology Micro-scale Electrification and Energization (under revision)",
    suppressed_demand_small_scale_methodology_for_energy_use_for_the_processing_of_agricultural_products_under_revision:
      "Suppressed Demand Small-scale Methodology for Energy Use for the Processing of Agricultural Products (under revision)",
    suppressed_demand_small_scale_methodology_for_low_ghg_food_preservation_under_revision:
      "Suppressed Demand Small-scale Methodology for Low GHG Food Preservation (under revision)",
    tero_001_redd: "TERO.001 - REDD+",
    tero_002_apd_avoided_planned_deforestation:
      "TERO.002 - APD (Avoided Planned Deforestation)",
    tero_003_carbon_stock_in_forests:
      "TERO.003 - Carbon Stock in Forests",
    tero_004_carbon_removal_in_agricultural_crops:
      "TERO.004 - Carbon Removal in Agricultural Crops",
    tero_005_reduction_of_ghg_emissions_via_electric_vehicles:
      "TERO.005 - Reduction of GHG Emissions via Electric Vehicles",
    tero_006_arr_afforestation_reforestation_and_revegetation:
      "TERO.006 - ARR (Afforestation, Reforestation, and Revegetation)",
    tero_007_agricultural_land_management_alm:
      "TERO.007 - Agricultural Land Management (ALM)",
    terrestrial_storage_of_biomass: "Terrestrial Storage of Biomass",
    the_gold_standard_simplified_methodology_for_clean_and_efficient_cookstoves:
      "The Gold Standard Simplified Methodology for Clean and Efficient Cookstoves",
    two_and_three_wheeled_personal_transportation:
      "Two and Three Wheeled Personal Transportation",
    vm0001_refrigerant_leak_detection:
      "VM0001 - Refrigerant Leak Detection",
    vm0003_improved_forest_management_through_extension_of_rotation_age:
      "VM0003 - Improved Forest Management through Extension of Rotation Age",
    vm0005_conversion_of_low_productive_forest_to_high_productive_forest:
      "VM0005 - Conversion of Low-Productive Forest to High-Productive Forest",
    vm0006_carbon_accounting_for_mosaic_and_landscape_scale_redd_projects:
      "VM0006 - Carbon Accounting for Mosaic and Landscape-scale REDD Projects",
    vm0007_redd_methodology_framework: "VM0007 - REDD+ Methodology Framework",
    vm0008_weatherization_of_single_family_and_multi_family_buildings:
      "VM0008 - Weatherization of Single Family and Multi-Family Buildings",
    vm0010_improved_forest_management_conversion_from_logged_to_protected_forest:
      "VM0010 - Improved Forest Management: Conversion from Logged to Protected Forest",
    vm0011_preventing_planned_degradation:
      "VM0011 - Preventing Planned Degradation",
    vm0015_avoided_unplanned_deforestation:
      "VM0015 - Avoided Unplanned Deforestation",
    vm0016_recovery_and_destruction_of_ozone_depleting_substances_ods_from_products:
      "VM0016 - Recovery and Destruction of Ozone-Depleting Substances (ODS) from Products",
    vm0018_energy_efficiency_and_solid_waste_diversion_activities_within_a_sustainable_community:
      "VM0018 - Energy Efficiency and Solid Waste Diversion Activities within a Sustainable Community",
    vm0019_fuel_switch_from_gasoline_to_ethanol_in_flex_fuel_vehicle_fleets:
      "VM0019 - Fuel Switch from Gasoline to Ethanol in Flex-Fuel Vehicle Fleets",
    vm0025_campus_clean_energy_and_energy_efficiency:
      "VM0025 - Campus Clean Energy and Energy Efficiency",
    vm0032_adoption_of_sustainable_grasslands_through_adjustment_of_fire_and_grazing:
      "VM0032 - Adoption of Sustainable Grasslands through Adjustment of Fire and Grazing",
    vm0033_tidal_wetland_and_seagrass_restoration:
      "VM0033 - Tidal Wetland and Seagrass Restoration",
    vm0035_improved_forest_management_through_reduced_impact_logging:
      "VM0035 - Improved Forest Management through Reduced Impact Logging",
    vm0038_electric_vehicle_charging_systems:
      "VM0038 - Electric Vehicle Charging Systems",
    vm0039_use_of_foam_stabilized_base_and_emulsion_asphalt_mixtures_in_pavement_application:
      "VM0039 - Use of Foam Stabilized Base and Emulsion Asphalt Mixtures in Pavement Application",
    vm0041_reduction_of_enteric_methane_emissions_from_ruminants_through_the_use_of_feed_ingredients:
      "VM0041 - Reduction of Enteric Methane Emissions from Ruminants through the Use of Feed Ingredients",
    vm0042_improved_agricultural_land_management:
      "VM0042 - Improved Agricultural Land Management",
    vm0043_co2_utilization_in_concrete_production:
      "VM0043 - CO2 Utilization in Concrete Production",
    vm0044_biochar_utilization_in_soil_and_non_soil_applications:
      "VM0044 - Biochar Utilization in Soil and Non-Soil Applications",
    vm0045_improved_forest_management_using_dynamic_matched_baselines_from_national_forest_inventories:
      "VM0045 - Improved Forest Management Using Dynamic Matched Baselines from National Forest Inventories",
    vm0046_reducing_food_loss_and_waste:
      "VM0046 - Reducing Food Loss and Waste",
    vm0047_afforestation_reforestation_and_revegetation:
      "VM0047 - Afforestation, Reforestation, and Revegetation",
    vm0048_vmd0055_reducing_emissions_from_unplanned_deforestation:
      "VM0048/VMD0055 - Reducing Emissions from Unplanned Deforestation",
    vm0049_carbon_capture_and_storage: "VM0049 - Carbon Capture and Storage",
    vm0050_energy_efficiency_and_fuel_switch_measures_in_cookstoves:
      "VM0050 - Energy Efficiency and Fuel-Switch Measures in Cookstoves",
    vm0051_improved_management_in_rice_production_systems:
      "VM0051 - Improved Management in Rice Production Systems",
    vm0052_accelerated_retirement_of_coal_fired_power_plants_using_a_just_transition:
      "VM0052 - Accelerated Retirement of Coal-Fired Power Plants Using a Just Transition",
    vmr0004_improved_efficiency_of_fleet_vehicles:
      "VMR0004 - Improved Efficiency of Fleet Vehicles",
    vmr0007_recovery_and_recycling_of_materials_from_solid_wastes:
      "VMR0007 - Recovery and Recycling of Materials from Solid Wastes",
    vmr0008_recovery_and_recycling_of_materials_from_e_waste:
      "VMR0008 - Recovery and Recycling of Materials from E-waste",
    vmr0009_avoided_emissions_from_biomass_wastes_through_use_as_feedstock_in_pulp_and_paper_cardboard_fiberboard_or_bio_oil_production:
      "VMR0009 - Avoided Emissions from Biomass Wastes through Use as Feedstock in Pulp and Paper, Cardboard, Fiberboard or Bio-oil Production",
    vmr0010_electricity_supply_for_ships:
      "VMR0010 - Electricity Supply for Ships",
    vmr0012_production_of_geopolymer_cement:
      "VMR0012 - Production of Geopolymer Cement",
    vmr0013_lightweight_two_and_three_wheeled_personal_transportation:
      "VMR0013 - Lightweight Two- and Three-Wheeled Personal Transportation",
    vmr0014_electric_and_hybrid_vehicles_and_mobile_machinery:
      "VMR0014 - Electric and Hybrid Vehicles and Mobile Machinery",
    vmr0015_low_greenhouse_gas_emitting_safe_drinking_water_production_systems:
      "VMR0015 - Low Greenhouse Gas Emitting Safe Drinking Water Production Systems",
    vmr0016_flaring_or_use_of_landfill_gas:
      "VMR0016 - Flaring or Use of Landfill Gas",
    wastewater_alkalinity_enhancement: "Wastewater Alkalinity Enhancement",
  },
};
